import React, { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import Has from '../../../component/Permission/Has';
import { Alert } from '../../../component/Alert/Alert';
import RegisterCompanyInformation from "../../../component/RegisterCompany/RegisterCompanyInformation";
import { REGISTER_COMPANIES } from "../../../config/PermissionTypes";
import { updateRegisteredCompany, getRegisteredCompany } from "../../../service/RegisterCompaniesService";
import _ from 'lodash';
import "./Register.css";

export default function EditRegisteredCompany(props) {
    const [company, setCompany] = useState({
        companyName: "",
        companyNumber: "",
        uuid: ""
    })
    const [originalCompanyValues, setOriginalCompanyValues] = useState({
        companyName: "",
        companyNumber: "",
        uuid: ""
    });
    const [errors, setErrors] = useState({});
    const [companyInfoUpdated, setCompanyInfoUpdated] = useState(false);
    const [savePending, setSavePending] = useState(false);
    const [banner, setBanner] = useState({
        show: false,
        type: "success",
        message: ""
    });
    const location = useLocation();
    const { uuid, companyNumber } = location.state;

    useEffect(() => {
        const dataHandler = (companyData) => {
            if (companyData) {
                const getCompany = {
                    companyName: companyData.companyRegistration.companyName,
                    companyNumber: companyData.companyRegistration.companyNumber,
                    uuid: companyData.companyRegistration.uuid
                }
                setCompany(getCompany);
                setOriginalCompanyValues(getCompany);
            } else {
                showBanner("error", `An error occurred while retrieving the company: ${companyNumber}`)
            }
        };
        getRegisteredCompany(uuid, dataHandler);
    }, [uuid, companyNumber])

    const handleCompanyUpdate = (field, value) => {
        let updatedCompany = { ...company };
        updatedCompany[field] = value
        setCompany(updatedCompany);
        if (updatedCompany[field] !== originalCompanyValues[field]) {
            setCompanyInfoUpdated(true);
        } else {
            setCompanyInfoUpdated(false);
        }
    }

    const isSaveDisabled = () => {
        const errorsExist = !_.isEmpty(errors);
        return !company.companyName || !company.companyName.replace(/\s/g, '').length || !company.companyNumber || errorsExist || savePending || !companyInfoUpdated;
    }

    const showBanner = (type, message) => {
        setBanner({
            show: true,
            type: type,
            message: message
        })
    }

    const handleSaveCompany = async () => {
        setSavePending(true);
        await Promise.resolve(updateRegisteredCompany(company))
            .then(() => {
                showBanner("success", <>The company was successfully updated! <Link to={"/system/registerCompanies"}>Back to Registered Companies page</Link></>);
                setSavePending(false);
                setOriginalCompanyValues(company);
                setCompanyInfoUpdated(false);
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    showBanner("error", error.response.data.message);
                } else {
                    showBanner("error", "An error occurred while trying to update the company.");
                }
                setSavePending(false);
            });
    }

    return (
        <><Has isPageLevel={true} permission={REGISTER_COMPANIES}>
            <div className="container-fluid edit-company-page" data-testid="edit-company-page">
                <div className="cb-row page-title-area">
                    <div className="cb-col-xs-8 cb-col-lg-8 page-title">
                        <h1 data-testid="edit-company-page-header-title">Edit Registered Company</h1>
                    </div>
                </div>

                <>{banner.show &&
                    <Alert type={`${banner.type}`} handleOnClose={() => setBanner({ show: false, message: "" })} dataTestId='edit-company-notification'>
                        < div style={{ fontWeight: '500' }}>{banner.message}</div>
                    </Alert>}

                    <div className="company-info-container" data-testid="company-info-fields">
                        <div className="sectionTitle">Company Information</div>
                        <RegisterCompanyInformation
                            companyName={company.companyName}
                            companyNumber={company.companyNumber}
                            errors={errors}
                            setErrors={setErrors}
                            handleFieldUpdate={handleCompanyUpdate}
                        />
                    </div>

                    <div className="company-buttons" data-testid="edit-company-buttons">
                        <Link to={"/system/registerCompanies"}>
                            <button
                                type="button"
                                className="cb-btn cb-btn-outline-secondary"
                                data-testid="edit-company-cancel"
                                disabled={false}
                                onClick={() => null}>
                                Cancel
                            </button>
                        </Link>
                        <button
                            className="cb-btn cb-btn-primary"
                            data-testid="edit-company-submit"
                            disabled={isSaveDisabled()}
                            onClick={() => handleSaveCompany()}
                        >
                            Update Company
                        </button>
                    </div>
                </>
            </div>
        </Has ></>
    )
}